<template>
  <div
    class="tabs mr-12"
    :class="{
      tabs_light: !isDark,
    }"
  >
    <div
      class="tabs-item"
      @click="changeView('list')"
      :class="{
        'tabs-item_active': 'list' === active,
      }"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0 5H20" :stroke="getColor('list')" stroke-width="4" />
        <path d="M0 16H10" :stroke="getColor('list')" stroke-width="2" />
        <path d="M0 11H20" :stroke="getColor('list')" stroke-width="2" />
      </svg>

      <div class="tabs-item__text">
        <span>Liste</span>
      </div>
    </div>

    <div
      class="tabs-item"
      @click="changeView('map')"
      :class="{
        'tabs-item_active': 'map' === active,
      }"
    >
      <svg
        width="22"
        height="20"
        viewBox="0 0 22 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1 3.72661L7.87781 1.11763L14.1278 3.6068L21 1V15.9805L14.1222 18.5898L7.87219 16.1003L1 18.7071V3.72661ZM13.8125 4.15169L8.1875 1.91115V15.5554L13.8125 17.7959V4.15169ZM1.625 4.15542L7.5625 1.90306V15.5517L1.625 17.804V4.15542ZM14.4375 17.804L20.375 15.5517V1.90306L14.4375 4.15542V17.804Z"
          :fill="getColor('map')"
        />
        <path
          d="M7.87781 1.11763L7.97031 0.885371L7.88002 0.849409L7.78914 0.883881L7.87781 1.11763ZM1 3.72661L0.911332 3.49286L0.75 3.55406V3.72661H1ZM14.1278 3.6068L14.0353 3.83906L14.1256 3.87502L14.2165 3.84055L14.1278 3.6068ZM21 1H21.25V0.637787L20.9113 0.766252L21 1ZM21 15.9805L21.0887 16.2142L21.25 16.153V15.9805H21ZM14.1222 18.5898L14.0297 18.822L14.12 18.858L14.2109 18.8235L14.1222 18.5898ZM7.87219 16.1003L7.9647 15.868L7.8744 15.8321L7.78352 15.8665L7.87219 16.1003ZM1 18.7071H0.75V19.0693L1.08867 18.9408L1 18.7071ZM8.1875 1.91115L8.28001 1.6789L7.9375 1.54247V1.91115H8.1875ZM13.8125 4.15169H14.0625V3.98217L13.905 3.91944L13.8125 4.15169ZM8.1875 15.5554H7.9375V15.7249L8.09499 15.7877L8.1875 15.5554ZM13.8125 17.7959L13.72 18.0282L14.0625 18.1646V17.7959H13.8125ZM7.5625 1.90306H7.8125V1.54084L7.47383 1.66931L7.5625 1.90306ZM1.625 4.15542L1.53633 3.92168L1.375 3.98288V4.15542H1.625ZM7.5625 15.5517L7.65117 15.7854L7.8125 15.7242V15.5517H7.5625ZM1.625 17.804H1.375V18.1663L1.71367 18.0378L1.625 17.804ZM20.375 15.5517L20.4637 15.7854L20.625 15.7242V15.5517H20.375ZM14.4375 17.804H14.1875V18.1663L14.5262 18.0378L14.4375 17.804ZM20.375 1.90306H20.625V1.54084L20.2863 1.66931L20.375 1.90306ZM14.4375 4.15542L14.3488 3.92168L14.1875 3.98288V4.15542H14.4375ZM7.78914 0.883881L0.911332 3.49286L1.08867 3.96036L7.96648 1.35138L7.78914 0.883881ZM14.2203 3.37455L7.97031 0.885371L7.78531 1.34989L14.0353 3.83906L14.2203 3.37455ZM20.9113 0.766252L14.0391 3.37306L14.2165 3.84055L21.0887 1.23375L20.9113 0.766252ZM21.25 15.9805V1H20.75V15.9805H21.25ZM14.2109 18.8235L21.0887 16.2142L20.9113 15.7467L14.0335 18.356L14.2109 18.8235ZM7.77968 16.3325L14.0297 18.822L14.2147 18.3575L7.9647 15.868L7.77968 16.3325ZM1.08867 18.9408L7.96085 16.334L7.78352 15.8665L0.911333 18.4734L1.08867 18.9408ZM0.75 3.72661V18.7071H1.25V3.72661H0.75ZM8.09499 2.14341L13.72 4.38394L13.905 3.91944L8.28001 1.6789L8.09499 2.14341ZM8.4375 15.5554V1.91115H7.9375V15.5554H8.4375ZM13.905 17.5637L8.28001 15.3232L8.09499 15.7877L13.72 18.0282L13.905 17.5637ZM13.5625 4.15169V17.7959H14.0625V4.15169H13.5625ZM7.47383 1.66931L1.53633 3.92168L1.71367 4.38917L7.65117 2.13681L7.47383 1.66931ZM7.8125 15.5517V1.90306H7.3125V15.5517H7.8125ZM1.71367 18.0378L7.65117 15.7854L7.47383 15.3179L1.53633 17.5703L1.71367 18.0378ZM1.375 4.15542V17.804H1.875V4.15542H1.375ZM20.2863 15.3179L14.3488 17.5703L14.5262 18.0378L20.4637 15.7854L20.2863 15.3179ZM20.125 1.90306V15.5517H20.625V1.90306H20.125ZM14.5262 4.38917L20.4637 2.13681L20.2863 1.66931L14.3488 3.92168L14.5262 4.38917ZM14.6875 17.804V4.15542H14.1875V17.804H14.6875Z"
          :fill="getColor('map')"
        />
      </svg>

      <div class="tabs-item__text">
        <span>Karte</span>
      </div>
    </div>

    <div
      class="tabs-item"
      @click="changeView('badges')"
      :class="{
        'tabs-item_active': 'badges' === active,
      }"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19 19.5V4.36578C19 3.48595 18.3553 2.77271 17.56 2.77271H2.44C1.64471 2.77271 1 3.48595 1 4.36578V19.5H19Z"
          :stroke="getColor('badges')"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.84216 2.54545C3.84216 1.41578 4.7965 0.5 5.97374 0.5C7.15098 0.5 8.10532 1.41578 8.10532 2.54545C8.10532 3.67513 7.15098 4.59091 5.97374 4.59091"
          :stroke="getColor('badges')"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.3684 2.54545C12.3684 1.41578 13.3227 0.5 14.5 0.5C15.6772 0.5 16.6316 1.41578 16.6316 2.54545C16.6316 3.67513 15.6772 4.59091 14.5 4.59091"
          :stroke="getColor('badges')"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <circle cx="13" cy="14.5" r="1.5" :fill="getColor('badges')" />
        <circle cx="7" cy="14.5" r="1.5" :fill="getColor('badges')" />
        <circle cx="7" cy="9.5" r="1.5" :fill="getColor('badges')" />
        <circle cx="13" cy="9.5" r="1.5" :fill="getColor('badges')" />
      </svg>

      <div class="tabs-item__text">
        <span>Abzeichen</span>
      </div>
    </div>

    <div
      class="tabs-item tabs-item_w150"
      @click="changeView('schedule')"
      :class="{
        'tabs-item_active': 'schedule' === active,
      }"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.9499 18.9999H2.05C1.45 18.9999 1 18.5499 1 17.9499V2.05C1 1.45 1.45 1 2.05 1H17.8749C18.4749 1 18.9249 1.45 18.9249 2.05V17.8749C18.9999 18.5499 18.5499 18.9999 17.9499 18.9999Z"
          :stroke="getColor('schedule')"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.99997 6.99997H1V2.05C1 1.45 1.45 1 2.05 1H6.99997V6.99997Z"
          :stroke="getColor('schedule')"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.9999 1H6.99994V6.99997H12.9999V1Z"
          :stroke="getColor('schedule')"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19 6.99997H13V1H17.95C18.55 1 19 1.45 19 2.05V6.99997Z"
          :stroke="getColor('schedule')"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.99997 6.99976H1V12.9997H6.99997V6.99976Z"
          :stroke="getColor('schedule')"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.9999 6.99976H6.99994V12.9997H12.9999V6.99976Z"
          :stroke="getColor('schedule')"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19 6.99976H13V12.9997H19V6.99976Z"
          :stroke="getColor('schedule')"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.99997 19H2.05C1.45 19 1 18.55 1 17.95V13H6.99997V19Z"
          :stroke="getColor('schedule')"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.9999 13H6.99994V19H12.9999V13Z"
          :stroke="getColor('schedule')"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.95 19H13V13H19V17.95C19 18.55 18.55 19 17.95 19Z"
          :stroke="getColor('schedule')"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.79999 8.80005L11.2 11.2"
          :stroke="getColor('schedule')"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.2 8.80005L8.79999 11.2"
          :stroke="getColor('schedule')"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2.79999 14.7998L5.19998 17.1998"
          :stroke="getColor('schedule')"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.19998 14.7998L2.79999 17.1998"
          :stroke="getColor('schedule')"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.7999 8.80005L17.1999 11.2"
          :stroke="getColor('schedule')"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.1999 8.80005L14.7999 11.2"
          :stroke="getColor('schedule')"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <div class="tabs-item__text">
        <span>Arbeitskalender</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: {
        active: {
            required: true,
        },
    },
    computed: {
        ...mapGetters({
            activeTheme: 'activeTheme',
        }),
        isDark() {
            return this.activeTheme === 'dark'
        },
    },
    methods: {
        changeView(view) {
            this.$emit('changeView', view)
        },
        getColor(tab) {
            if (tab === this.active) {
                return this.isDark ? '#000' : '#304156'
            }

            return this.isDark ? '#fff' : '#304156'
        },
    },
}
</script>
